import { CSSProperties } from 'react';
import styled  from 'styled-components';

import Button, { TButtonSize } from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

type TButtonProps = {
    $justify?: CSSProperties['justifyContent'],
    size?: TButtonSize,
    isStatic?: boolean,
}

const getIndentByType = (size: TButtonSize) => {
    switch (size) {
        case 'small':
        case 'medium':
            return 8;
        case 'large':
            return 12;
    }
};

export const ButtonGroup = styled.div<TButtonProps>`
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: ${({ $justify = 'flex-start' }) => $justify};
    row-gap: ${({ size = 'large' }) => `${getIndentByType(size)}px`};

    ${Button} {
        width: 100%;
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        flex-direction: row;
        column-gap: ${({ size = 'large' }) => `${getIndentByType(size)}px`};

        ${Button} {
            width: auto;
        }
    }

    ${({ isStatic = false, size = 'large' }) => {
        return isStatic
            ? `
            flex-direction: row;
            column-gap: ${getIndentByType(size)}px;

            ${Button} {
                width: auto;
            }
        `
            : '';
    }}
`;
